import React from 'react';
import { Navigate } from 'react-router-dom';

import { useTheme } from '../theme/ThemeContext';
import { usePermissions } from '../context/PermissionContext';
import { ROUTES } from '../constants/routes';
import AdminPageHeader from '../components/common/AdminPageHeader';
import LabQueueView from '../components/lab/LabQueueView';

export default function LabQueuePage() {
  const { isDark } = useTheme();
  const { hasPermission } = usePermissions();

  const bg = isDark
    ? 'linear-gradient(135deg, #0E0E0F 0%, #1a1a2e 50%, #0E0E0F 100%)'
    : 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%)';

  // Redirect home (not /access-denied, whose only button logs out) on a
  // missing feature permission in an authenticated session.
  if (!hasPermission('VIEW_LAB_QUEUE')) {
    return <Navigate to={ROUTES.ORG} replace />;
  }

  return (
    <div style={{ minHeight: '100vh', background: bg }}>
      <AdminPageHeader />
      <main className="max-w-3xl mx-auto px-4 pb-16 pt-4">
        <LabQueueView />
      </main>
    </div>
  );
}
